import { Fragment, useId } from 'react'

import { DotButton } from '@/components/button'

const ProgressIndicator = ({
  numOfItems,
  activeIndex,
  onClick,
}: {
  numOfItems: number
  activeIndex: number
  onClick: (index: number) => void
}) => {
  const id = useId()
  const arr = Array.from(Array(numOfItems).keys())

  return (
    <div className="progress">
      {(arr || []).map((index) => (
        <Fragment key={`${id}_${index}`}>
          <DotButton
            isActive={activeIndex === index}
            onClick={() => onClick(index)}
          />
        </Fragment>
      ))}
    </div>
  )
}

export default ProgressIndicator
